import Top from "../components/templates/top";
import { useNavigate } from "react-router-dom";
import listText from "../utils/dictionaries/dictionary-data-confirmation";
import { store } from "../redux/store";
import { useEffect, useState } from "react";
import Paragraph from "../components/atoms/paragraph";
import Loader from "../components/atoms/loader";
import Button from "../components/atoms/button";
import Link from "../components/atoms/link";
import Title from "../components/atoms/title";
import { useDispatch } from "react-redux";
import BottomSheetMessage from "../components/templates/bottom-sheet-message";
import TitleAndImage from "../components/molecules/title-and-image";
import IneModel from "../assets/images/ine-model.png";
import Input from "../components/molecules/input";
import * as yup from "yup";
import { useFormik } from "formik";
import UtilsCommonsService from "../services/utilsCommons.service";
import { useApi } from "../hooks/useApi";
import { ICatalog, IZipCode } from "../interfaces/api/IUtilsCommons.interface";
import PersonalDataService from "../services/personalData.service";
import { DataINEuseCase } from "../../application/use-cases/dataINE.usecase";
import { addConfirmData, credentialData, principalAddress } from "../redux/slices/confirmDataReducer";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";

const DataConfirmation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const states = store.getState();
  const [isOpenBottonSheet, setOpenBottonSheet] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const { getZipCode } = new UtilsCommonsService();
  const { getNationality } = new UtilsCommonsService();
  const { getCountries } = new UtilsCommonsService();

  const postConfirmData = new PersonalDataService();
  const useCasePostConfirmData = new DataINEuseCase(postConfirmData);

  const { data: dataGetZipCode = [],
    execute: executeGetZipCode,
    isLoading: isLoadingGetZipCode,
    error: errorGetZipCode } = useApi<
      IZipCode[],
      { zipCode: number; processId: string }
    >(getZipCode);

  const { data: dataGetNationality = [],
    execute: executeGetNationality
  } = useApi<
    ICatalog[],
    { processId: string }
  >(getNationality);

  const { data: dataGetCountries = [],
    execute: executeGetCountries
  } = useApi<
    ICatalog[],
    { processId: string }
  >(getCountries);

  const formik = useFormik({
    initialValues: {
      name1: states.client.confirmData.name1,
      name2: states.client.confirmData.name2,
      lastName1: states.client.confirmData.lastName1,
      lastName2: states.client.confirmData.lastName2,
      dateBirth: states?.client?.confirmData?.dateBirth,
      gender: states.client.confirmData.gender,
      nationality: states.client.confirmData.nationality,
      curp: states.client.confirmData.curp,
      phone: states.client.confirmData?.phone,
      email: states.client.confirmData?.email,
      placeBirth: states.client.confirmData?.placeBirth,
      township: states.client.confirmData?.principalAddress?.township,
      townshipId: states.client.confirmData.principalAddress?.townshipId,
      zipCode: states.client.confirmData.principalAddress?.zipCode,
      state: states.client.confirmData.principalAddress?.state,
      stateId: states.client.confirmData.principalAddress?.stateId,
      stateCRM: states.client.confirmData.principalAddress?.stateCRM,
      suburbs: states.client.confirmData.principalAddress.suburbs,
      street: states.client.confirmData.principalAddress?.street,
      externalNumber: states.client.confirmData.principalAddress?.externalNumber,
      internalNumber: "",
      country: states.client.confirmData.principalAddress?.country,
      electorKey: states.client.confirmData.credentialData?.electorKey,
      dateOfExpiration: states.client.confirmData.credentialData?.dateOfExpiration,
      dateOfIssue: states.client.confirmData.credentialData?.dateOfIssue,
      ocr: states.client.confirmData.credentialData?.ocr,
      cic: states.client.confirmData.credentialData?.cic,
    },
    onSubmit: (values) => console.log(values),
    validationSchema: yup.object({
      name1: yup.string().required("Campo requerido"),
      lastName1: yup.string().required("Campo requerido"),
      lastName2: yup.string(),
      curp: yup.string().required("Campo requerido"),
      street: yup.string().required("Campo requerido"),
      externalNumber: yup.string().required("Campo requerido"),
      electorKey: yup.string().required("Campo requerido"),
      ocr: yup.string().required("Campo requerido"),
      cic: yup.string().required("Campo requerido"),
      phone: yup.string(),
      email: yup.string(),
      zipCode: yup
        .string()
        .required("Campo requerido")
        .min(5, "Debe contener 5 caracteres")
        .max(5, "Debe contener 5 caracteres"),
    }),
  });

  useEffect(() => {
    if (dataGetZipCode.length) {
      formik.setFieldValue("state", dataGetZipCode[0]?.state);
      formik.setFieldValue("stateId", dataGetZipCode[0]?.stateId);
      formik.setFieldValue("stateCRM", dataGetZipCode[0]?.stateCRM);
      formik.setFieldValue("township", dataGetZipCode[0]?.township);
      formik.setFieldValue("suburbs", dataGetZipCode[0]?.suburbs[0]);
      formik.setFieldValue("townshipId", dataGetZipCode[0]?.townshipId);
    }
  }, [dataGetZipCode]);

  useEffect(() => {
    if (String(formik.values?.zipCode).length === 5) {
      executeGetZipCode({
        zipCode: Number(formik.values?.zipCode),
        processId: states?.client?.clientPersist?.uuid,
      });
    } else {
      if (dataGetZipCode[0]) {
        dataGetZipCode[0].state = "";
        dataGetZipCode[0].stateId = "";
        dataGetZipCode[0].suburbs = [];
        dataGetZipCode[0].township = "";
        dataGetZipCode[0].townshipId = "";
      }
    }
    executeGetNationality({ processId: states?.client?.clientPersist?.uuid });
    executeGetCountries({ processId: states?.client?.clientPersist?.uuid });

    if (isLoadingGetZipCode && errorGetZipCode) {
      setModalShow(true)
    }
  }, [formik.values?.zipCode, 
    errorGetZipCode, isLoadingGetZipCode
  ]);

  const [day, setDay] = useState(new Date(formik.values.dateBirth).getDate() + 1);
  const [month, setMonth] = useState(String((new Date(formik.values.dateBirth).getMonth() + 1)).padStart(2, '0'));
  const [year, setYear] = useState(new Date(formik.values.dateBirth).getFullYear());
  const days = Array.from(Array(31 + 1).keys()).slice(1);
  const [modalShow, setModalShow] = useState(false);

  const months = [
    { key: "01", value: "Enero" },
    { key: "02", value: "Febrero" },
    { key: "03", value: "Marzo" },
    { key: "04", value: "Abril" },
    { key: "05", value: "Mayo" },
    { key: "06", value: "Junio" },
    { key: "07", value: "Julio" },
    { key: "08", value: "Agosto" },
    { key: "09", value: "Septiembre" },
    { key: "10", value: "Octubre" },
    { key: "11", value: "Noviembre" },
    { key: "12", value: "Diciembre" },
  ];

  const years = Array(2005 - 1900 + 1)
    .fill(undefined)
    .map((_, i) => i + 1900);


  const handleChange = (value: any, e: any) => {
    switch (value) {
      case "day":
        setDay(e);
        break;
      case "month":
        setMonth(String(e).padStart(2, '0'));
        break;
      case "year":
        setYear(e);
        break;
    }
  };

  const submit = async () => {
    setShowSpinner(true);
    var payload = {
      credentialData: {
        cic: formik.values?.cic,
        dateOfIssue: formik.values?.dateOfIssue,
        dateOfExpiration: formik.values?.dateOfExpiration,
        electorKey: formik.values?.electorKey,
        ocr: formik.values?.ocr
      },
      curp: formik.values.curp,
      dateBirth: year + "-" + month + "-" + day,
      email: formik.values.email,
      gender: formik.values.gender,
      lastName1: formik.values.lastName1,
      lastName2: formik.values.lastName2,
      name1: formik.values.name1,
      name2: formik.values.name2,
      nationality: formik.values.nationality,
      phone: formik.values.phone,
      placeBirth: formik.values.placeBirth,
      principalAddress: {
        zipCode: formik.values.zipCode,
        state: formik.values.state,
        stateId: formik.values.stateId,
        stateCRM: formik.values.stateCRM,
        suburbs: formik.values.suburbs,
        street: formik.values.street,
        externalNumber: formik.values.externalNumber,
        internalNumber: formik.values.internalNumber,
        townshipId: formik.values.townshipId,
        township: formik.values.township,
        country: formik.values.country
      },
      processId: states.client.clientPersist.uuid
    }

    dispatch(addConfirmData(payload))
    dispatch(credentialData(payload.credentialData))
    dispatch(principalAddress(payload.principalAddress))
    const response = await useCasePostConfirmData.postConfirmData(payload, states.client.clientPersist.uuid);
    if (response.error !== null) {
      setModalShow(true);
    } else {
      navigate("/BlackLists");
    }
    setShowSpinner(false);
  };

  const functionProcessModal = () => {
    setModalShow(false);
  };

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/DataConfirmation",
        step: "CONTINUE_AFTER",
        data: formik.values, // Agregar data del formulario
      },
    });
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={listText.text_2.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={"m-2"}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"45%"}
          comeFrom={"/DataConfirmation"}
          onClickGoBackIcon={() => navigate("/")}
        />

        <div className="p-3">
          <div className="my-2">
            <Paragraph
              text={listText.text_3.mainText}
              className={"fs-6"}
              styleParagraph={undefined}
            />
          </div>
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id={listText.text_4.mainText}>
                <button
                  className="accordion-button left-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${listText.text_4.mainText}`.replace(/\s+/g, "")}
                  aria-expanded="true"
                  aria-controls={`collapse${listText.text_4.mainText}`.replace(/\s+/g, "")}
                >
                  <Title
                    text={listText.text_4.mainText}
                    className={"fw-bold"}
                    styleTitle={{ color: "#00376F" }}
                  />
                </button>
              </h2>
              <div
                id={`collapse${listText.text_4.mainText}`.replace(/\s+/g, "")}
                className={"accordion-collapse collapse show"}
                aria-labelledby={`collapse${listText.text_4.mainText}`.replace(/\s+/g, "")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <div className="row mb-4_3 mt-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.name1 ? "is-invalid" : ""
                          }`}
                        type="text"
                        id="name1"
                        name="name1"
                        placeholder=""
                        value={formik.values.name1 || ""}
                        error={formik.errors.name1 || ""}
                        text="Primer nombre"
                        onChange={(e: any) =>
                          formik.setFieldValue("name1", e.target.value.toUpperCase())
                        }
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={"form-control fs-6"}
                        type="text"
                        id="name2"
                        name="name2"
                        placeholder="N/A"
                        value={formik.values.name2 || ""}
                        error={formik.errors.name2}
                        text="Segundo nombre (Opcional)"
                        onChange={(e: any) =>
                          formik.setFieldValue("name2", e.target.value.toUpperCase())
                        }
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.lastName1 ? "is-invalid" : ""
                          }`}
                        type="text"
                        id="lastName1"
                        name="lastName1"
                        placeholder=""
                        value={formik.values.lastName1 || ""}
                        error={formik.errors.lastName1}
                        text="Apellido paterno"
                        onChange={(e: any) =>
                          formik.setFieldValue("lastName1", e.target.value.toUpperCase())
                        }
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.lastName2 ? "is-invalid" : ""
                          }`}
                        type="text"
                        id="lastName2"
                        name="lastName2"
                        placeholder=""
                        value={formik.values.lastName2 || ""}
                        error={formik.errors.lastName2}
                        text="Apellido materno"
                        onChange={(e: any) =>
                          formik.setFieldValue("lastName2", e.target.value.toUpperCase())
                        }
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 align-self-center">
                      <Paragraph
                        text={"Ingresa tu fecha y lugar de nacimiento"}
                        className={"fs-6 mb-3"}
                        styleParagraph={{ marginTop: "0px" }}
                      />
                    </div>
                  </div>

                  <div className="row mb-4_3 px-2 d-flex">
                    <div className="col-4 px-1">
                      <div className="form-floating">
                        <select
                          className="form-select py-0"
                          value={day || ""}
                          onChange={(e: any) => handleChange("day", e.target.value)}
                        >
                          {days.map((item: any) => {
                            return (
                              <option
                                key={item}
                                value={item}
                                disabled={
                                  month == "02" && (item == 30 || item == 31) ? true : false
                                }
                              >
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="col-4 px-1">
                      <div className="form-floating">
                        <select
                          className="form-select py-0"
                          value={month || ""}
                          onChange={(e: any) => handleChange("month", e.target.value)}
                        >
                          {months.map((item) => {
                            return (
                              <option
                                key={item?.key}
                                value={item?.key || ""}
                                disabled={
                                  item?.key == "02" && (day == 30 || day == 31) ? true : false
                                }
                              >
                                {item.value}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="col-4 px-1">
                      <div className="form-floating">
                        <select
                          className="form-select py-0"
                          value={year || ""}
                          onChange={(e: any) => handleChange("year", e.target.value)}
                        >
                          {years.map((item) => {
                            return (
                              <option key={item} value={item || ""}>
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4_3 px-2">
                    <div className="col-12 px-1">
                      <div className="form-floating">
                        <select
                          className="form-select py-0"
                          id="gender"
                          value={formik.values.gender}
                          onChange={(e: any) => formik.setFieldValue("gender", e.target.value)}
                        >
                          <option value="" disabled>
                            Seleccionar una opción
                          </option>
                          <option value="H">Hombre</option>
                          <option value="M">Mujer</option>
                          <option value="X">No binario</option>
                        </select>
                        <label htmlFor="gender" className="dark-gray">
                          Género
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <div className="form-floating">
                        <select
                          className="form-select py-0 "
                          id="nationality"
                          value={formik.values.nationality}
                          onChange={(e: any) => {
                            formik.setFieldValue("nationality", e.target.value);
                          }}
                        >
                          <option value="" disabled>
                            Seleccionar una opción
                          </option>
                          {dataGetNationality?.map((nationality: any) => {
                            return (
                              <option key={nationality.key} value={nationality.key}>
                                {nationality.description}
                              </option>
                            );
                          })}
                        </select>
                        <label htmlFor="nationality" className="dark-gray">
                          {listText.text_11.mainText}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.curp ? "is-invalid" : ""}`}
                        type="text"
                        id="curp"
                        name="curp"
                        placeholder=""
                        value={formik.values.curp || ""}
                        error={formik.errors.curp}
                        text="CURP"
                        onChange={(e: any) =>
                          formik.setFieldValue("curp", e.target.value.toUpperCase())
                        }
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <div className="form-floating">
                        <select
                          className="form-select py-0"
                          id="placeBirth"
                          value={formik.values.placeBirth}
                          onChange={(e: any) => {
                            formik.setFieldValue("placeBirth", e.target.value);
                          }}
                        >
                          <option value="" disabled>
                            Seleccionar una opción
                          </option>
                          {dataGetCountries?.map((country: any) => {
                            return (
                              <option key={country.key} value={country.key}>
                                {country.description}
                              </option>
                            );
                          })}
                        </select>
                        <label htmlFor="placeBirth" className="dark-gray">
                          {listText.text_13.mainText}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id={listText.text_14.mainText}>
                <button
                  className="accordion-button left-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${listText.text_14.mainText}`?.replace(/\s+/g, "")}
                  aria-expanded="true"
                  aria-controls={`collapse${listText.text_14.mainText}`?.replace(/\s+/g, "")}
                >
                  <Title
                    text={listText.text_14.mainText}
                    className={"fw-bold"}
                    styleTitle={{ color: "#00376F" }}
                  />
                </button>
              </h2>
              <div
                id={`collapse${listText.text_14.mainText}`?.replace(/\s+/g, "")}
                className={"accordion-collapse collapse collapsed"}
                aria-labelledby={`collapse${listText.text_14.mainText}`?.replace(/\s+/g, "")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <div className="row mb-0">
                    <div className="col-5 align-self-center">
                      <Paragraph
                        text={listText.text_15.mainText}
                        className={"fs-7 mb-0"}
                        styleParagraph={{ marginTop: "0px" }}
                      />
                    </div>
                    <div className="col-7">
                      <Input
                        className={
                          "form-control px-3 py-2 fs-7 border border-0 bg-transparent h-auto min-height-auto"
                        }
                        type="text"
                        id="phone"
                        name="phone"
                        placeholder=""
                        value={formik.values.phone || ""}
                        error={formik.errors.phone}
                        text=""
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={true}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-5 align-self-center">
                      <Paragraph
                        text={listText.text_16.mainText}
                        className={"fs-7 mb-0"}
                        styleParagraph={{ marginTop: "0px" }}
                      />
                    </div>
                    <div className="col-7">
                      <Input
                        className={
                          "form-control px-3 py-2 fs-7 border border-0 bg-transparent h-auto min-height-auto"
                        }
                        type="email"
                        id="email"
                        name="email"
                        placeholder=""
                        value={formik.values.email || ""}
                        error={formik.errors.email}
                        text=""
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={true}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id={listText.text_17.mainText}>
                <button
                  className="accordion-button left-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${listText.text_17.mainText}`?.replace(/\s+/g, "")}
                  aria-expanded="true"
                  aria-controls={`collapse${listText.text_17.mainText}`?.replace(/\s+/g, "")}
                >
                  <Title
                    text={listText.text_17.mainText}
                    className={"fw-bold"}
                    styleTitle={{ color: "#00376F" }}
                  />
                </button>
              </h2>
              <div
                id={`collapse${listText.text_17.mainText}`?.replace(/\s+/g, "")}
                className={"accordion-collapse collapse collapsed"}
                aria-labelledby={`collapse${listText.text_17.mainText}`?.replace(/\s+/g, "")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <div className="row mb-4_3">
                    <div className="col-12">
                      <div className="form-floating">
                        <select
                          className="form-select py-0"
                          id="placeBirth"
                          value={formik.values.placeBirth}
                          onChange={(e: any) => {
                            formik.setFieldValue("placeBirth", e.target.value);
                          }}
                        >
                          <option value="" disabled>
                            Seleccionar una opción
                          </option>
                          {dataGetCountries?.map((country: any) => {
                            return (
                              <option key={country?.key} value={country?.key}>
                                {country?.description}
                              </option>
                            );
                          })}
                        </select>
                        <label htmlFor="placeBirth" className="dark-gray">
                          {listText.text_18.mainText}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control fs-6 ${formik.errors.zipCode ? "is-invalid" : ""
                          }`}
                        type="text"
                        id="zipCode"
                        name="zipCode"
                        placeholder=""
                        value={formik.values.zipCode || ""}
                        error={formik.errors.zipCode}
                        text={listText.text_19.mainText}
                        onChange={(e: any) => {
                          formik.setFieldValue("zipCode", e.target.value);
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3 px-2">
                    <div className="col-12 px-1">
                      <div className="form-floating">
                        <select
                          className={
                            "form-select py-0 " +
                            (formik.errors.zipCode ? "pe-none" : "pe-auto")
                          }
                          id="state"
                          value={formik.errors.zipCode ? "" : formik.values.state}
                          onChange={(e: any) => {
                            formik.setFieldValue("state", e.target.value);
                          }}
                        >
                          <option
                            key={dataGetZipCode[0]?.state}
                            value={dataGetZipCode[0]?.state}
                          >
                            {dataGetZipCode[0]?.state}
                          </option>
                        </select>
                        <label htmlFor="state" className="dark-gray">
                          {listText.text_20.mainText}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4_3 px-2">
                    <div className="col-12 px-1">
                      <div className="form-floating">
                        <select
                          className={
                            "form-select py-0 " +
                            (formik.errors.zipCode ? "pe-none" : "pe-auto")
                          }
                          id="suburbs"
                          value={formik.values.suburbs}
                          onChange={(e: any) => formik.setFieldValue("suburbs", e.target.value)}
                        >
                          {dataGetZipCode[0]?.suburbs.map((item: any) => {
                            return (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            );
                          })}
                        </select>
                        <label htmlFor="suburbs" className="dark-gray">
                          {listText.text_21.mainText}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.street ? "is-invalid" : ""}`}
                        type="text"
                        id="street"
                        name="street"
                        placeholder=""
                        value={formik.values.street || ""}
                        error={formik.errors.street}
                        text={listText.text_22.mainText}
                        onChange={(e: any) => {
                          formik.setFieldValue("street", e.target.value.toUpperCase());
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.externalNumber ? "is-invalid" : ""}`}
                        type="text"
                        id="externalNumber"
                        name="externalNumber"
                        placeholder=""
                        value={formik.values.externalNumber || ""}
                        error={formik.errors.externalNumber}
                        text={listText.text_23.mainText}
                        onChange={(e: any) => {
                          formik.setFieldValue("externalNumber", e.target.value.toUpperCase());
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item text-left">
              <h2 className="accordion-header" id={listText.text_24.mainText}>
                <button
                  className="accordion-button left-auto"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${listText.text_24.mainText}`?.replace(/\s+/g, "")}
                  aria-expanded="true"
                  aria-controls={`collapse${listText.text_24.mainText}`?.replace(/\s+/g, "")}
                >
                  <Title
                    text={listText.text_24.mainText}
                    className={"fw-bold"}
                    styleTitle={{ color: "#00376F" }}
                  />
                </button>
              </h2>
              <div
                id={`collapse${listText.text_24.mainText}`?.replace(/\s+/g, "")}
                className={"accordion-collapse collapse collapsed"}
                aria-labelledby={`collapse${listText.text_24.mainText}`?.replace(/\s+/g, "")}
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.electorKey ? "is-invalid" : ""
                          }`}
                        type="text"
                        id="electorKey"
                        name="electorKey"
                        placeholder=""
                        value={formik.values.electorKey || ""}
                        error={formik.errors.electorKey}
                        text={listText.text_25.mainText}
                        onChange={(e: any) => {
                          formik.setFieldValue("electorKey", e.target.value.toUpperCase());
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.dateOfExpiration ? "is-invalid" : ""
                          }`}
                        type="number"
                        id="dateOfExpiration"
                        name="dateOfExpiration"
                        placeholder=""
                        value={formik.values.dateOfExpiration || ""}
                        error={formik.errors.dateOfExpiration}
                        text={listText.text_26.mainText}
                        onChange={(e: any) => {
                          formik.setFieldValue(
                            "dateOfExpiration",
                            e.target.value.toUpperCase(),
                          );
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.dateOfIssue ? "is-invalid" : ""
                          }`}
                        type="number"
                        id="dateOfIssue"
                        name="dateOfIssue"
                        placeholder=""
                        value={formik.values.dateOfIssue || ""}
                        error={formik.errors.dateOfIssue}
                        text={listText.text_27.mainText}
                        onChange={(e: any) => {
                          formik.setFieldValue("dateOfIssue", e.target.value.toUpperCase());
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-4_3">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.ocr ? "is-invalid" : ""}`}
                        type="text"
                        id="ocr"
                        name="ocr"
                        placeholder=""
                        value={formik.values.ocr || ""}
                        error={formik.errors.ocr}
                        text={listText.text_28.mainText || ""}
                        onChange={(e: any) => {
                          formik.setFieldValue("ocr", e.target.value.toUpperCase());
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-12">
                      <Input
                        className={`form-control ${formik.errors.cic ? "is-invalid" : ""}`}
                        type="number"
                        id="cic"
                        name="cic"
                        placeholder=""
                        value={formik.values.cic || ""}
                        error={formik.errors.cic}
                        text={listText.text_29.mainText || ""}
                        onChange={(e: any) => {
                          formik.setFieldValue("cic", e.target.value.toUpperCase());
                        }}
                        onBlur={formik.handleBlur}
                        src=""
                        disabled={false}
                        style={undefined}
                        displayLabel="dark-gray"
                        htmlFor={""}
                      ></Input>
                    </div>
                  </div>

                  <div className="mb-3">
                    <TitleAndImage
                      srcImage={""}
                      titleText={listText.text_30.mainText}
                      displayLeftImageTitle={""}
                      classTitle={""}
                      styleTitle={{
                        color: "#005CB9",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                      onClickTitleImgeDiv={() => setOpenBottonSheet(true)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer--pin">
        <Button
          text={listText.text_31.mainText}
          divClassName={"w-100 mt-5"}
          buttonClassName={`${showSpinner ? "pe-none" : ""
            } btn-bg-primary text-white w-100 place-content-center align-self-center`}
          spinner={showSpinner}
          onClick={() => submit()}
          disabled={!formik.isValid}
          dataBsDismiss={undefined}
        />
        <div className="text-center mt-3">
          <Link
            text={"Seguir más tarde"}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={followLaterAction}
            className={""}
          />
        </div>
      </div>
      <BottomSheetMessage
        title={listText.text_32.mainText}
        text={listText.text_33.mainText}
        isOpen={isOpenBottonSheet}
        imageInside={IneModel}
        onClickClose={() => setOpenBottonSheet(false)}
      />

      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle="¡Ups lo sentimos!"
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: "Reintentar",
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              functionProcessModal();
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default DataConfirmation;